<template>
  <section class="project">
    <div class="content">
      <div class="search">
        <div class="name">城市:</div>
        <div @click="setCity(item.id)" :class="item.id === activeCity?'city active':'city'" v-for="(item, index) in cityList" :key="index"><span>{{item.name}}</span></div>
      </div>
      <ul class="list">
        <li v-for="(item, index) in dataList" :key="index" @click="goDetails(item.id)">
          <div class="img">
            <img :src="item.main_img?item.main_img:defaultImg" alt="">
          </div>
          <div class="bottom">
            <p class="title overflow-ellipsis1">{{item.project_full_name}}</p>
            <p class="address overflow-ellipsis1" :title="item.project_address"><i class="el-icon-location-outline"></i><span>{{item.project_address}}</span>
            </p>
          </div>
        </li>
        <p class="unData" v-if="dataList.length === 0">暂无该城市乐璟项目</p>
      </ul>
      <!-- <div class="page">
        <el-pagination
          class="my_pagination"
          @size-change="handleSizeChange"
          :page-size="filter.pageSize"
          :page-sizes="pageSizeOption"
          background
          @current-change="handleCurrentChange"
          layout="total, sizes, prev, pager, next, jumper"
          :current-page.sync="filter.currentPage"
          :total="totalItems"
          :page-count="totalPage">
        </el-pagination>
      </div> -->
    </div>
  </section>
</template>

<script>
  import {mapState, mapActions} from 'vuex'
  import mixin from '../../mixin/baseMixin'
  import defaultImg from '../../assets/img/wutu.jpg'
  export default {
    mixins: [mixin],
    data() {
      return {
        activeCity: '',
        pageSizeOption: [9, 18, 27, 48],
        defaultImg: defaultImg,
        filter: {
          page_num: 1,
          page_size: 9
        },
      }
    },
    computed: {
      ...mapState({
        cityList: state => state.cityList,
        dataList: state => state.projectList,
        description: state => state.description
      })
    },
    methods: {
      ...mapActions([
        'getCityList',
        'getProjectList'
      ]),
      goDetails(id) {
        this.$router.push(`/communityDetails/${id}.html`)
      },
      setCity(id) {
        this.activeCity = id
        this.search()
      },
      search() {
        this.filter.id = this.activeCity
        this.getProjectList(this.filter).then(res => {
          document.querySelector('meta[name=description]').setAttribute('content', this.description)
        })
      }
    },
    mounted() {
      this.getCityList()
      this.search()
    }
  }
</script>

<style lang="stylus" scoped>
  .project
    padding-top 50px
    padding-bottom 100px
    .content
      font-family:PingFangSC-Medium
      width 1125px
      margin 0 auto
      .search
        overflow hidden
        padding 15px 20px
        border 1px dashed #00B8D4
        .name
          float left
          height: 33px
          line-height: 33px
          color #333
          font-size 18px
          margin-right 19px
        .city
          cursor pointer
          float left
          width: 88px
          height: 33px
          line-height: 33px
          text-align: center
          margin-right: 15px
          border-radius: 15px
          color #666666
          font-size 16px
          background:linear-gradient(90deg,rgba(127,241,251,0),rgba(0,184,212,0))
          transition all 0.5s
        .active
          color #fff
          background:linear-gradient(90deg,rgba(127,241,251,1),rgba(0,184,212,1))
          transition all 0.5s
      .list
        overflow hidden
        margin-top 40px
        .unData
          text-align: center;
          color: #c0c0c0;
        li
          cursor pointer
          float left
          width 360px
          height 293px
          margin-right 20px
          margin-bottom 47px
          transition all 0.5s
          &:hover
            transform: translate(5px, 5px)
            box-shadow: 0px 2px 26px 3px rgba(4,6,15,0.06)
            transition all 0.5s
          &:nth-child(3n+3)
            margin-right 0
          .img
            width 360px
            height 200px
            background-color #000088
            img
              width 100%
              height 100%

          .bottom
            height 93px
            padding 0 21px
            border-left 1px solid #ECECEC
            border-right 1px solid #ECECEC
            border-bottom 1px solid #ECECEC
            .title
              color #333333
              font-size 16px
              font-weight 600
              padding-top: 22px
            .address
              margin-top 12px
              font-size 14px
              color #666666
              i
                color #00A5CA
                margin-right 6px
      .page
        text-align center
        margin-top 32px
</style>
